import React, { lazy, Suspense } from "react";
import { Loading } from "../../common/Loading";
import { LoginLogTableHead } from "./LoginLogTableHead";
import { LoginLogTableMenu } from "./LoginLogTableMenu";
const LoginLogTableBody = lazy(() => import("./LoginLogTableBody"));

export const LoginLogTable = React.memo(function LoginLogTable() {
    return (
        <>
            {/* CSV保存・検索 */}
            <LoginLogTableMenu />
            {/* ログイン履歴のリスト */}
            <table>
                <LoginLogTableHead />
                <Suspense fallback={<TableLoading />}>
                    <LoginLogTableBody />
                </Suspense>
            </table>
        </>
    );
});

const TableLoading = React.memo(function TableLoading() {
    return (
        <tbody>
            <tr>
                <td><Loading /></td>
            </tr>
        </tbody>
    );
});
